var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.bookingHasNoShortlistedTalent
      ? _c("div", { staticClass: "no-stars" }, [
          _c("p", [
            _vm._v(
              "\n      There are no " +
                _vm._s(_vm.$t("shortlisted stars")) +
                ".\n    "
            ),
          ]),
        ])
      : _c(
          "ul",
          { staticClass: "shortlist shortlist-horizontal shortlist-col-4" },
          _vm._l(_vm.bookingShortlistedTalent, function (talent, index) {
            return _c("booking-duplicate-shortlist-talent", {
              key: talent.id,
              attrs: {
                talent: talent,
                index: index,
                booking: _vm.booking,
                "remove-shortlisted-talent": _vm.removeShortlistedTalent,
              },
            })
          }),
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }